import React from "react";
import { Button } from "./style.js";
import { Icon } from "semantic-ui-react";

export default class IconButton extends React.Component {
  render() {
    const { icon, color, className, tooltip, onClick } = this.props;
    const buttonClass = `${color} ${className} ${tooltip ? "with-tooltip" : ""}`;
    return (
      <Button className={buttonClass} data-custom-tooltip={tooltip} onClick={onClick}>
        <Icon name={icon} style={{ lineHeight: icon === "add" ? "20px" : "" }} />
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IconButton/index.jsx